import { DatePipe, NgClass, NgFor, NgIf, DecimalPipe, TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { TranslationService, I18nModule } from '@spartacus/core';
import moment from 'moment';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormArray, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Contracts } from '../../../core/model/contracts-model';
import { ToastrService } from 'ngx-toastr';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDateParserFormatter, DateRangePickerI18nService } from 'src/app/shared/services/date-range-picker-i18n.service';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';

@Component({
    selector: 'app-my-contracts',
    templateUrl: './my-contracts.component.html',
    styleUrls: ['./my-contracts.component.scss'],
    providers: [{ provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService }, { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
    imports: [CommonPageBreadcrumbsComponent, NgClass, FormsModule, ReactiveFormsModule, NgbInputDatepicker, NgFor, NgIf, NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, DecimalPipe, TitleCasePipe, I18nModule]
})
export class MyContractsComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  firstFieldEmittedValue: IDateRange;
  secondFieldOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD/MM/YYYY',
    icons: 'font-awesome',
    minDate: moment().subtract(10, 'years'),
    maxDate: moment().add(1, 'year'),
  };
  stateofCollapse = true;
  enable = false;
  title: any;
  navigationData: string;
  form: UntypedFormGroup = null;
  checkedform: UntypedFormGroup;
  searchInput: any;
  contractsDataCopy: any;
  form2: UntypedFormGroup = null;
  loaderShow = false;
  noOfItemsToShow = 8;
  reachedToEnd = false;
  page = 0;
  query = '';
  myGroup: UntypedFormGroup;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  datePipe = new DatePipe('en-US');
  pageSize = 5;
  currentPage = 1;
  sampleProduct = [];
  samplePort = [];
  sampleProductName = [];
  data: any;
  productsList = [];
  status = [];
  searchValue = null;
  productTypes = [];
    shipmentTab: string = 'INPROGRESS';
  contractsData: Array<Contracts>;
  selectedStatus: any;
  selectedMaterial: any;
  selectedMaterialString:string;
  value: string;
  activeTab: string = 'Active';
  sideBar: boolean;
  checkArray: any;
  length: number;
  contractsDataMain: Contracts[] = [];
  checkedportform: UntypedFormGroup;
  checkedproductform: UntypedFormGroup;
  statusLength = 0;
  productLength = 0;
  date = 0;
  displayLoading = true;
  noData = false;
  clearBtn = false;
  error: string;
  toDate: string = null;
  fromDate: string = null;
  hoveredDate: NgbDate | null = null;
  startDate: NgbDate | null = null;
  endDate: NgbDate | null = null;
  nextMonth: string;
  preMonth: string;
  productlist=[]
  selectMonth: string;
  selectYear: string;
  statusfilter: string;
  constructor(
    private translation: TranslationService, private customProductService: CustomProductsService, private fb: UntypedFormBuilder,
    private toastService: ToastrService, private userAccountFacade: UserAccountFacade, private calendar: NgbCalendar,

    public formatter: NgbDateParserFormatter
  ) {
    this.checkedportform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedproductform = this.fb.group({
      checkArray: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.sideBar = true;

    this.userAccountFacade.get().subscribe((res: any) => {
      if (res) {
        this.getContractsData();
        this.customProductService.languageChange$.subscribe(data => {
          this.displayLoading = true;
          if (data != null) {
            this.status = [];
            this.productsList = [];
            this.productsFilterData(this.shipmentTab);
            this.getContractsData();
          }
        });
        this.contractsDataMain = this.contractsData;
      }
    });
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl()
    });
    this.form2 = new UntypedFormGroup({
      secondDateRange2: new UntypedFormControl()
    });
    this.myGroup = new UntypedFormGroup({
      myGroupInput: new UntypedFormControl()
    });
    this.translation.translate('breadcrumb.myContracts.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.myContracts.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
    this.translation.translate('home.datePicker.nextMonth').subscribe(res => {
      this.nextMonth = res;
    })
    this.translation.translate('home.datePicker.preMonth').subscribe(res => {
      this.preMonth = res;
    })
    this.translation.translate('home.datePicker.selectMonth').subscribe(res => {
      this.selectMonth = res;
    })
    this.translation.translate('home.datePicker.selectyear').subscribe(res => {
      this.selectYear = res;
    })
  }
  isValidLetter(k): any {
    return ((k >= 48 && k <= 57 && k !== 0));
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    return this.isValidLetter(k);
  }

  onDateSelection(date: any, datepicker) {

    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (this.startDate && !this.endDate && date && date.after(this.startDate)) {
      this.endDate = date;
      this.filterData();
      datepicker.close();
    } else {
      this.endDate = null;
      this.startDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.startDate && !this.endDate && this.hoveredDate && date.after(this.startDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.endDate && date.after(this.startDate) && date.before(this.endDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.startDate) || (this.endDate && date.equals(this.endDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  resetCalendar(datepicker) {
    this.clearFilterData();
  }
  checkPad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  clearFilterDataMobile(event): void {
    this.closeBar();
    const checked = false;
    // this.status.forEach(item => item.selected = checked);
    this.productlist.forEach(item => item.selected = checked);
    this.date = 0;
    this.statusLength = 0;
    this.productLength = 0;
    this.startDate = null;
    this.endDate = null;
    this.selectedStatus = null;
    this.selectedMaterial = null;
    this.length = this.statusLength + this.productLength + this.date;
    this.noData = false;
    this.searchValue = '';
    this.getContractsData();
  }
  clearFilterData(): any {
    this.startDate = null;
    this.endDate = null;
    this.selectedStatus = null;
    this.selectedMaterial = null;
    this.noData = false;
    this.searchValue = '';
    this.productLength = 0;
    this.getContractsData();
  }
  onRangeSelected(value: IDateRange): void {
    this.firstFieldEmittedValue = value;
    this.startDate = this.dateFormatToddmmyyyy(this.firstFieldEmittedValue.start.toString());
    this.endDate = this.dateFormatToddmmyyyy(this.firstFieldEmittedValue.end.toString());
    this.date = 1;
    this.filterData();
  }

  dateFormatToddmmyyyy(str): any {
    // tslint:disable-next-line:one-variable-per-declaration
    const date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join('-');
  }

  invoice(contractId): void {
  }

  searchContracts(): void {
    this.searchValue.toLowerCase();
    if (this.searchValue) {
      this.getContractsData(this.selectedStatus, this.selectedMaterial, this.searchValue);
    }
    else {
      this.getContractsData( this.selectedStatus, this.selectedMaterial, this.searchValue);
      this.noData = false;
    }
  }

  onRangeSelectedMobile(value: IDateRange): void {
    this.firstFieldEmittedValue = value;
    this.startDate = this.dateFormatToddmmyyyy(this.firstFieldEmittedValue.start.toString());
    this.endDate = this.dateFormatToddmmyyyy(this.firstFieldEmittedValue.end.toString());
    this.date = 1;
  }

  onReset(event: Event): void {
    if (event !== undefined) {
      this.dateRangePicker?.reset(event);
      this.dateRangePicker?.toggleCalendarVisibility(false);
    }
    this.dateRangePicker?.toggleCalendarVisibility(false);
    this.startDate = null;
    this.endDate = null;
    this.date = 0;
    if (!this.selectedMaterial && !this.selectedStatus) {
      this.clearBtn = false;
    }
  }

  getContractsData(status?, product?, search?): void {
    this.displayLoading = true;
    this.noData = false;
    if (this.startDate != undefined && this.endDate != undefined) {
      this.fromDate = this.startDate?.year + '-' + this.checkPad(this.startDate?.month) + '-' + this.checkPad(this.startDate?.day);
      this.toDate = this.endDate?.year + '-' + this.checkPad(this.endDate?.month) + '-' + this.checkPad(this.endDate?.day);
    } else {
      this.fromDate = null;
      this.toDate = null;
    }
    status=status?status:this.shipmentTab
    this.selectedMaterialString =  product?.length>0?product?.join(':'):'';
    product=this.selectedMaterialString
   
    this.customProductService.getContractData(this.fromDate, this.toDate, status, product, search).subscribe(result => {
      this.displayLoading = false;
      if (result != null && result !== undefined) {
        if (result.ctcontract != null && result.ctcontract !== undefined) {
          this.contractsData = result.ctcontract;
          this.contractsDataCopy = this.contractsData;
        }
      }
      if (result.ctcontract.length === 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
    },
      err => {
        this.toastService.show(this.error);
        this.displayLoading = false;
      });
  }
  filterData(): void {
    if(this.selectedMaterial?.length >0 || this.startDate || this.endDate){
       this.getContractsData(this.selectedStatus, this.selectedMaterial, this.searchValue);
    }else{
      this.clearFilterData();
    }
  }

  onScroll(): void {
    if (this.contractsDataCopy.length === this.contractsData.length) {
      this.loaderShow = false;
      this.reachedToEnd = true;
    }
    else {
      this.loaderShow = true;
      setTimeout(() => {
        this.loadNextDataProducts();
      }, 1000);
    }
  }

  loadNextDataProducts(): void {
    this.page += this.noOfItemsToShow;
    // tslint:disable-next-line:prefer-const
    let arrLength = this.page + this.noOfItemsToShow;
    for (let i = this.page; i < arrLength; i++) {
      if (i < this.contractsDataCopy.length) {
        this.contractsData.push(this.contractsDataCopy[i]);
      }
      else {
        break;
      }
    }
    this.loaderShow = false;
  }

  productsFilterData(shipmentTab: string): void {
    this.statusfilter=shipmentTab
    this.customProductService.getContractFilters(this.statusfilter)
      .subscribe(data => {

        if (data) {
          this.status = data.shipmentStatus;
          this.productsList = data.products;
          this.productlist=this.productsList.map(item=>
            typeof item==='string'?{name:item,selected:false}:item);}
          
        
      });
  }

  filterSideBar(): void {
    this.sideBar = false;
  }
  closeBar(): void {
    this.sideBar = true;
  }
  onCheckboxportChange(e, id): void {
    this.statusLength = 1;
    const checkArray: UntypedFormArray = this.checkedportform.get('checkArray') as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      }
      );
      this.statusLength = 0;
    }
    if (checkArray.length > 0) {
      this.statusLength = 1;
    }
    this.status.forEach(item => {
      if (item.id !== id) {
        item.selected = false;
      }
    }
    );
    if (e.target.checked) {
      this.selectedStatus = id;
    } else {
      this.selectedStatus = null;
      this.statusLength = 0;
    }
  }

  onCheckboxproductChange(e, id): void {
    this.productLength = 1;
    const checkArray: UntypedFormArray = this.checkedproductform.get('checkArray') as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
      // this.productlist.forEach(item => {
      //   if (item.name === id) {
      //     item.selected = true;
      //   }
      // })
    } else {
      let i = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.productLength = 0;
    }
   this.selectedMaterial=checkArray.value 
  }

  getContractsResults(): void {
    this.closeBar();
    this.length = this.statusLength + this.productLength + this.date;
    this.filterData();
  }

  convertDate(dateData): any {
    if (dateData) {
      return moment.utc(dateData).local().format('DD/MM/YYYY');
    }
    else {
      return '--';
    }

  }

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for (let i = 0; i < element3.length; i++) {
      let value = element3[i].getAttribute("title");
      element3[i].setAttribute("title", this.setTitle(value));
    }

    let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
    for (let i = 0; i < element4.length; i++) {
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title", this.setTitle(value))
    }
  }
  setTitle(value) {
    switch (value) {
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default: return;
    }
  }

  clear(): void {
    this.checkedportform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedproductform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.productLength = 0;
    this.statusLength = 0;
    this.startDate = null;
    this.endDate = null;
    this.date = 0;
    this.closeBar();
    this.length = this.statusLength + this.productLength + this.date;
    this.status.forEach(item => {
      item.selected = false;
    });
    this.productlist.forEach(item => {
      item.selected = false;
    });
  }
  changeTab(data) {
        this.activeTab = data;
    if (this.activeTab === 'Active') {
      this.shipmentTab = 'INPROGRESS';
      this.getContractsData(this.shipmentTab,this.selectedMaterial||'')
      this.productsFilterData(this.shipmentTab)
      // show active tab
    }
    else if (this.activeTab === 'Completed') {
      // show completed tab
      this.shipmentTab = 'COMPLETED';
      this.getContractsData(this.shipmentTab,this.selectedMaterial||'')
      this.productsFilterData(this.shipmentTab)

    }

  }
}
